import { AnimatePresence, motion } from 'framer-motion'
import { useIsFetching } from 'react-query'

import NoResultsPlaceholder from '@/molecules/NoResultPlaceholder'
import Pagination from '@/organisms/Pagination/Pagination'

import { ContentProps } from '../../ts'
import FetchingMask from './includes/FetchingMask'

function Content(props: ContentProps) {
  const { children, isVisible, noResults, totalItems, topPosition } = props

  const motionKey = noResults ? 'no_results' : 'content'
  const isFetching = useIsFetching() > 0

  return (
    <AnimatePresence exitBeforeEnter>
      <motion.div
        key={motionKey}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1, transition: { delay: 0.2 } }}
        exit={{ opacity: 0 }}
      >
        {isVisible && (
          <div className="relative">
            <FetchingMask isFetching={isFetching} />
            {children}
            <Pagination
              className="mt-12 xl:mt-32"
              totalItems={totalItems}
              scrollViewOffsetTop={topPosition}
            />
          </div>
        )}
        {noResults && <NoResultsPlaceholder />}
      </motion.div>
    </AnimatePresence>
  )
}

export default Content
